import React, { useState, useEffect, useContext, useRef } from "react"; /*st48236 - 508 compliance*/
import { Accordion } from "react-bootstrap";
import ViewDetailsModal from "../../components/modal";
import TableCard from "../../components/CoverageTable.jsx";
import { getApiService } from "../../services/ApiService";
import { Spinner } from "react-bootstrap";
import { GetPayLoad } from "../../services/PayLoadStorage";
import { LanguageContext } from "../../contexts/LanguageContext";
import "../../assets/css/Style.css";
import Cookies from "js-cookie";

const Coverage = ({ variant, pageType }) => {
    const [activeKey, setActiveKey] = useState(null);
    const [modalId, setModalId] = useState();
    const [modal, setModal] = useState();
    const [coverageInfo, setCoverageInfo] = useState([]);
    const [coverageHeader, setCoverageHeader] = useState([]);
    const [coveragePrd, setCoveragePrdInfo] = useState([]);
    const [isLoading, setLoading] = useState(true,);
    const [nextBillDate, setNextBillDate] = useState('N/A');
    const [paidStatus, setPaidStatus] = useState([]);
    const { pageContent } = useContext(LanguageContext);
    const [coveragesContent, setCoveragesContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);
    const [errorFlag, setErrorFlag] = useState(false);
    const [caseInfo, setCaseInfo] = useState([]);

    const Payload = GetPayLoad('PayLoad');
    const ref = useRef(null); //st48236 - 508 compliance
    const [isContentReady, setContentReady] = useState(false); // st48236 - 508 compliance Track when all API responses are received
    const [apiCallsCompleted, setApiCallsCompleted] = useState(false); // st48236 - 508 compliance Track when all API calls are completed
    const modalRows = [
        {
            name_value: coverageInfo?.custodial?.custDisplayName,
            email_value: coverageInfo?.custodial?.custEmail,
            phone_value: coverageInfo?.custodial?.custodial_primary_phone_label !== '' ? coverageInfo?.custodial?.custodial_primary_phone_label +" - "+coverageInfo?.custodial?.custPhone : coverageInfo?.custodial?.custPhone,/* st48236 - INC0288091 - display primary phone type */
            address_value: coverageInfo?.custodial?.custAddress,
            secondary_phone_value: coverageInfo?.custodial?.custodial_sec_phone_label !== '' ? coverageInfo?.custodial?.custodial_sec_phone_label +" - "+coverageInfo?.custodial?.custSecondaryPhone : coverageInfo?.custodial?.custSecondaryPhone,/* st48236 - INC0288091 - display secondary phone type */
        },
        {
            name_value: coverageInfo?.responsible?.respDisplayName,
            email_value: coverageInfo?.responsible?.respEmail,
            phone_value: coverageInfo?.responsible?.resparty_primary_phone_label !== '' ? coverageInfo?.responsible?.resparty_primary_phone_label +" - "+coverageInfo?.responsible?.respPhone : coverageInfo?.responsible?.respPhone,/* st48236 - INC0288091 - display primary phone type */
            address_value: coverageInfo?.responsible?.respAddress,
            secondary_phone_value: coverageInfo?.responsible?.resparty_sec_phone_label !== '' ? coverageInfo?.responsible?.resparty_sec_phone_label +" - "+coverageInfo?.responsible?.respSecondaryPhone : coverageInfo?.responsible?.respSecondaryPhone,/* st48236 - INC0288091 - display secondary phone type */
        },
    ]

    const handleModal = (modal, index) => {
        setModal(modal)
        setModalId(index)
    }

    // Set icons based on owning carrier
    let owningCarrier = Payload?.owning_carrier || '';
    const connectiCareCarrier = Cookies.get("connectiCareCarrier") || null;
    const isConnectiCareCarrier = Cookies.get("isConnectiCareCarrier") || 'false';
    const [coverageDetailsIcon, setCoverageDetailsIcon] = useState(null);
    const [viewIcon, setViewIcon] = useState(null);
    const [creditCoverageIcon, setCreditCoverageIcon] = useState(null);
   
    useEffect(() => {
        // When ConnectiCare carrier is set, override owningCarrier
        owningCarrier = ( isConnectiCareCarrier === 'true' && connectiCareCarrier !== null && connectiCareCarrier !== undefined) ? connectiCareCarrier : owningCarrier;
        import("../../assets/images/Coverage/Coverage-details-"+owningCarrier+".svg")
                .then((image) => {
                    setCoverageDetailsIcon(image.default);
        }).catch(() => {
                // Load default image if carrier-specific image doesn't exist
                import("../../assets/images/Coverage/Coverage-details.svg").then((image) => {
                    setCoverageDetailsIcon(image.default);
                });
        });

        // Dynamic import for view icon based on carrier
        import("../../assets/images/icons/view-"+owningCarrier+".svg")
                .then((image) => {
                    setViewIcon(image.default);
        }).catch(() => {
                // Load default image if carrier-specific image doesn't exist
                import("../../assets/images/icons/view.svg").then((image) => {
                    setViewIcon(image.default);
                });
        });

        // Dynamic import for credit coverage icon based on carrier
        import("../../assets/images/Coverage/credit-Coverage-"+owningCarrier+".svg")
                .then((image) => {
                    setCreditCoverageIcon(image.default);
        }).catch(() => {
                // Load default image if carrier-specific image doesn't exist
                import("../../assets/images/Coverage/credit-Coverage.svg").then((image) => {
                    setCreditCoverageIcon(image.default);
                });
        });
    }, [owningCarrier, connectiCareCarrier]);

    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const headers = {
            "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
            "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
            "X-Hps-Region": Payload?.region,
            "X-Hps-Carrier": Payload?.owning_carrier
        };

    useEffect(() => {
        if (pageContent?.coverage) {
            setCoveragesContent(pageContent.coverage);
        }

        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }
         const targetCoverageUrl = process.env.REACT_APP_API_COVERAGE_INFO_ENDPOINT;
        getApiService(baseUrl, targetCoverageUrl, { cim: Payload?.cim }, headers)
            .then((response) => {
                setLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setErrorFlag(true);
                } else {
                    const coverageCount = response.data.data.coverages.length;
                    const arrCoveragesPrd = response.data.data.coverages;
                    const arrHeaders = []
                    for (let i = coverageCount; i >= 1; i--) {
						
                        arrHeaders.push({
                            id: coveragesContent?.coverage_coverages_id,
                            plan: coveragesContent?.coverage_coverages_plan_name,
                            coverage: coveragesContent?.coverage_coverages_coverage ?? '',
                            product: coveragesContent?.coverage_coverages_prod_type,
                            premium: coveragesContent?.coverage_coverages_premium,
                            memberId: coveragesContent?.coverage_coverages_memberid,
                            date: coveragesContent?.coverage_coverages_effective_date,
                            termdate: coveragesContent?.coverage_coverages_term_date,
                            dependents: coveragesContent?.coverage_coverages_name_of_dependents
                        })
                    }
                    // Add dependent click text to each coverage item
                    arrCoveragesPrd.forEach((item) => {
                        item['depClick'] = coveragesContent?.coverage_coverages_dependents_click_review;
                    }
                    ); 
                    setErrorFlag(false);
					setCoverageHeader(arrHeaders);
                    setCoveragePrdInfo(arrCoveragesPrd);
                    setCoverageInfo(response.data.data);
                    setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed 
                }
            })
            .catch(error => {
                setLoading(false);
                setErrorFlag(true);
            });
    }, [pageContent, coveragesContent]);

    useEffect(() => {
        const targetCaseAmountUrl = process.env.REACT_APP_API_CASE_BILL_DETAILS_ENDPOINT;
        getApiService(baseUrl, targetCaseAmountUrl, { cim: Payload?.cim, apiSource: 'recentBilling' }, headers)
            .then((response) => {
                if (response?.data && response?.data?.status === 'SUCCESS') {
                    if (response?.data?.data?.DueDate !== 'N/A') {
                        const date = new Date(response?.data?.data?.DueDate);
                        const formattedDate = date.toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                        });
                        setNextBillDate(formattedDate);
                    }
                    const currentDue = response?.data?.data?.CurrentDueAmount;
                    const number = parseFloat(currentDue.replace("$", ""));
                    if (number.toFixed(2) > 0) {
                        setPaidStatus('unpaid');
                    } else {
                        setPaidStatus('paid');
                    }
                    // st48236 - 508 compliance Mark API calls as completed
                    setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed
                }
            })
            .catch(error => {
                console.error('Error fetching case inforamtion data:', error);
            });

            //Get Case info to dispaly Policy Summary information
            const targetCaseInfoUrl = process.env.REACT_APP_API_CASE_INFO_ENDPOINT;
            getApiService(baseUrl, targetCaseInfoUrl, { cim: Payload?.cim }, headers)
                .then((response) => {
                    if (response?.data && response?.data?.status === 'SUCCESS') {
                        setCaseInfo(response.data.data);
                        setErrorFlag(false);
                    }else{
                        setErrorFlag(true);
                        setLoading(false);
                    }
                }).catch(error => {
                    setLoading(false);
                    setErrorFlag(true);
                }
            );

    }, [Payload?.cim, baseUrl, Payload?.region]);

    const modalColumns = [
        {
            name: coveragesContent?.coverage_customer_info_custodial_name,
            email: coveragesContent?.coverage_customer_info_custodial_email,
            phone: coveragesContent?.coverage_customer_info_custodial_phone,
            address: coveragesContent?.coverage_customer_info_custodial_address,
            secondary_phone: coveragesContent?.coverage_customer_info_custodial_sec_phone
        },
        {
            name: coveragesContent?.coverage_customer_info_responsible_name,
            email: coveragesContent?.coverage_customer_info_responsible_email,
            phone: coveragesContent?.coverage_customer_info_responsible_phone,
            address: coveragesContent?.coverage_customer_info_responsible_address,
            secondary_phone: coveragesContent?.coverage_customer_info_responsible_sec_phone
        },
    ]

    /*st48236 - 508 compliance*/      
    // Mark content as ready
    const [userInteracted, setUserInteracted] = useState(false);
        
        useEffect(() => {
          const handleUserInteraction = () => {
            setUserInteracted(true);
          };
        
          // Listen for user interactions
          document.addEventListener('click', handleUserInteraction);
          document.addEventListener('keydown', handleUserInteraction);
          
          return () => {
            document.removeEventListener('click', handleUserInteraction);
            document.removeEventListener('keydown', handleUserInteraction);
          };
        }, []);
        
        useEffect(() => {
          let timeoutId;
          
          if (apiCallsCompleted && !isContentReady) {
            timeoutId = setTimeout(() => {
              setContentReady(true);
              
              // Only auto-focus if user hasn't interacted
              if (!userInteracted && ref.current) {
                requestAnimationFrame(() => {
                  ref.current.focus({ preventScroll: true });
                });
              }
            }, parseInt(process.env.REACT_APP_READABILITY_TIMEOUT));
          }
          
          return () => {
            if (timeoutId) clearTimeout(timeoutId);
          };
        }, [apiCallsCompleted, isContentReady, userInteracted]);
    
    /*st48236 - 508 compliance*/

    return (
        <>
        <main
            role="main"
            tabIndex="-1" // Make the <main> tag focusable
            ref={ref} // Attach the ref to the <main> tag
            style={{ outline: 'none' }} // revmove border
            aria-label="Coverage Page"
        > {/*st48236 - 508 compliance*/}                          
            <div>
                <div className="conatiner-fluid content-inner mt-n5 py-0">
                    <div className="row">
                        <div className="col-md-12 col-xl-12">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card" data-aos="fade-up" data-aos-delay="800">
                                        <div className="col-md-12 col-xl-12">
                                            <div className="">
                                                <div className="d-xl-flex d-md-block d-sm-block d-block mb-4 mb-4">
                                                    <div className="col-xl-8 col-md-12 col-sm-12 mt-3 card-body">
                                                        <h5 tabIndex={0} className="fw-semibold">{coveragesContent?.coverage_customer_info}</h5>
                                                        {errorFlag && (
                                                            <div className="api-error-msg">
                                                                {genericContent?.case_info_service_error}
                                                            </div>
                                                        )}
                                                        {isLoading && (
                                                            <div style={{ display: '-webkit-inline-box', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                                                                <Spinner animation="border" role="status" ></Spinner>
                                                                <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                                            </div>
                                                        )}
                                                        {!errorFlag && !isLoading && (
                                                            <div className="d-xl-flex d-md-flex mt-4">
                                                                <div className="col-xl-2 me-2 col-md-2">
                                                                    <button tabIndex={-1} className={`align-items-center avatar-50 user-circle nav-link${Payload?.owning_carrier === 'Q5' ? ' no-hover' : ''}`} data-bs-toggle="dropdown" aria-expanded="false">
                                                                        {coverageInfo?.profileName}
                                                                    </button>
                                                                </div>
                                                                <div className="col-xl-10 col-md-10">
                                                                    <div className="mb-2 d-xl-block d-md-block d-sm-block d-block">
                                                                        <div className="col-xl-12 d-xl-flex d-md-flex mb-4">
                                                                            <div tabIndex={0} className="col-xl-3 col-md-3 labels">
                                                                                <label className="label-heading">{coveragesContent?.coverage_customer_info_mail_name}</label>
                                                                                <label className="label-name fw-medium">{coverageInfo?.displayName}</label>
                                                                            </div>
                                                                            <div tabIndex={0} className="col-xl-3 col-md-3 labels">
                                                                                <label className="label-heading">{coveragesContent?.coverage_customer_info_memberid}</label>
                                                                                <label className="label-name fw-medium">{coverageInfo?.carrierSubId}</label>
                                                                            </div>
                                                                            <div tabIndex={0} className="col-xl-6 col-md-6 labels">
                                                                                <label className="label-heading">{coveragesContent?.coverage_customer_info_email}</label>
                                                                                <label className="label-name fw-medium">{coverageInfo?.email}</label>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-xl-12 d-xl-flex d-md-flex mb-4">
                                                                            <div tabIndex={0} className="col-xl-6 col-md-6 labels">
                                                                                <label className="label-heading">{coveragesContent?.coverage_customer_info_maill_address}</label>
                                                                                <label className="label-name fw-medium">{coverageInfo?.mailAddress}</label>
                                                                            </div>
                                                                            {/* st48236 - INC0288091 - display secondary phone number - start */}
                                                                            <div tabIndex={0} className="col-xl-6 col-md-6 labels">
                                                                                <label className="label-heading">{coveragesContent?.coverage_customer_info_phone}</label>
                                                                                <label className="label-name fw-medium">{(coverageInfo?.phoneNumber !== 'N/A') && (coverageInfo?.phoneType && coverageInfo?.phoneType !== '' ? coverageInfo?.phoneType +" - "+coverageInfo?.phoneNumber : coverageInfo?.phoneNumber)}</label>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-xl-12 d-xl-flex d-md-flex mb-4">
                                                                            <div tabIndex={0} className="col-xl-4 col-md-4 labels">
                                                                                <label className="label-heading">{coveragesContent?.coverage_customer_info_sec_phone}</label>
                                                                                <label className="label-name fw-medium">{coverageInfo?.secondaryPhoneType !== '' ? coverageInfo?.secondaryPhoneType +" - "+coverageInfo?.secondaryPhone : coverageInfo?.secondaryPhone}</label>
                                                                            </div>
                                                                        <div tabIndex={0} className="col-xl-4 col-md-4 labels col-sm-4 col-6">
                                                                                    <label className="label-heading">{coveragesContent?.coverage_customer_info_custodial}</label>
                                                                                    <button
                                                                                        className="btn btns btn-outline-primary"
                                                                                        aria-label ="Custodial View Details" //st48236 - 508 compliance
                                                                                        onClick={() => handleModal(coveragesContent?.coverage_customer_info_custodial, 0)}>
                                                                                        {coveragesContent?.coverage_customer_info_view_more}
                                                                                        {Payload?.owning_carrier !== 'Q5' && (
                                                                                            <img src={viewIcon} className="ms-1" alt="view" />
                                                                                        )}
                                                                                    </button>
                                                                                </div>
                                                                            <div tabIndex={0} className="col-xl-4 col-md-4 col-sm-4 col-6 labels">
                                                                                    <label className="label-heading">{coveragesContent?.coverage_customer_info_responsible}</label>
                                                                                    <button
                                                                                        className="btn btns btn-outline-primary"
                                                                                        aria-label ="Responsible Party View Details" //st48236 - 508 compliance
                                                                                        onClick={() => handleModal(coveragesContent?.coverage_customer_info_responsible, 1)}
                                                                                    >
                                                                                        {coveragesContent?.coverage_customer_info_view_more}
                                                                                        {Payload?.owning_carrier !== 'Q5' && (
                                                                                            <img src={viewIcon} className="ms-1" alt="view" />
                                                                                        )}
                                                                                    </button>
                                                                                </div>
                                                                        </div>
                                                                    </div>
                                                                    <ViewDetailsModal 
                                                                        column={modalColumns[modalId]} 
                                                                        row={modalRows[modalId]} 
                                                                        modal={modal} 
                                                                        setModal={setModal} 
                                                                        pageType={Payload?.owning_carrier === 'Q5' ? undefined : "policy"} 
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="col-xl-4 col-md-12 col-sm-12 mt-3 card-body">
                                                        <h5 tabIndex={0} className="fw-semibold mb-3">{coveragesContent?.coverage_policy_summary_title}</h5>
                                                        {errorFlag && (
                                                            <div tabIndex={0} className="api-error-msg">
                                                                {genericContent?.policy_info_service_error}
                                                            </div>
                                                        )}
                                                        {isLoading && (
                                                            <div tabIndex={0} style={{ display: '-webkit-inline-box', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                                                                <Spinner animation="border" role="status" ></Spinner>
                                                                <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                                            </div>
                                                        )}
                                                        {!errorFlag && !isLoading && (
                                                            <div className="card card-ssn coveragescard">
                                                                <div className="card-body policy-summary">
                                                                    <div tabIndex={0} className="col-12 d-flex mb-3">
                                                                        <div className="col-6">
                                                                            <p className="h6 text-white">{coveragesContent?.coverage_policy_summary_status}</p>
                                                                            <p className="h4 text-white">{caseInfo?.caseStatus}</p>
                                                                        </div>
                                                                        
                                                                    </div>
                                                                    <div className="col-12 d-flex mb-3">
                                                                        <div tabIndex={0} className="col-7">
                                                                            <p aria-label="application received date" className="h6 text-white">{coveragesContent?.coverage_policy_summary_app_recv_date}</p>
                                                                            <p className="h5 text-white fw-semibold">{caseInfo?.recvDate}</p>
                                                                        </div>
                                                                        <div tabIndex={0} className="col-5 text-end">
                                                                            <p className="h6 text-white">{coveragesContent?.coverage_policy_summary_issue_date}</p>
                                                                            <p className="h5 text-white fw-semibold">{caseInfo?.issueDate}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-12 d-flex">
                                                                        <div tabIndex={0} className="col-7">
                                                                            <p className="h6 text-white">{coveragesContent?.coverage_policy_summary_effective_date}</p>
                                                                            <p className="h5 text-white fw-semibold">{caseInfo?.effectiveDt}</p>
                                                                        </div>
                                                                        <div tabIndex={0} className="col-5 text-end">
                                                                            <p className="h6 text-white">{coveragesContent?.coverage_policy_summary_term_date}</p>
                                                                            <p className="h5 text-white fw-semibold">{caseInfo?.termDate}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="mt-2 card-ssn-btm">
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="card" data-aos="fade-up" data-aos-delay="800">
                                        <div className="col-md-12 col-xl-12">
                                            <div className="row" style={{ gap: '20px' }}>
                                            {Payload?.owning_carrier === 'Q5' &&(
                                                <div className="mb-4 mb-4">
                                                    <div className="d-xl-flex d-lg-flex d-md-block d-sm-block d-block align-items-center col-12 mt-3 card-body">
                                                        <div tabIndex={0} className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 d-flex">
                                                            <h5 className="fw-semibold mb-0 me-3">{coveragesContent?.coverage_coverage_details}</h5>
                                                        </div>
                                                        {isLoading && (
                                                            <div tabIndex={0} style={{ display: '-webkit-inline-box', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                                                                <Spinner animation="border" role="status" ></Spinner>
                                                                <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                                            </div>
                                                        )}
                                                        <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 text-xl-end text-lg-end text-md-start text-sm-start text-start mt-md-2 mt-lg-0">                                                                    
                                                            <div className="d-flex flex-wrap align-items-center justify-content-xl-end justify-content-lg-end justify-content-md-start justify-content-sm-start justify-content-start gap-2">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary rounded gap-2"
                                                            >
                                                                {coveragePrd?.length} {coveragesContent?.coverage_product_text}
                                                                {coveragePrd?.length > 1 ? 's' : ''}
                                                                {coveragesContent?.coverage_enrolled_text}
                                                            </button>
                                                            <h6 tabIndex={0} className="fw-semibold mb-0 h6">
                                                                <img src={creditCoverageIcon}
                                                                    className={`me-1 ${Payload?.owning_carrier === 'Q5' ? 'q5-navy-icon' : ''}`} alt="Coverage-Card" />
                                                                {coveragesContent?.coverage_next_billing_date_text} {nextBillDate}
                                                            </h6>
                                                                <div className="d-flex align-items-center gap-2">
                                                            <label tabIndex={0} className="mt-1 labels">
                                                                <span className="label-heading">{coveragesContent?.coverage_status_text}</span>
                                                            </label>
                                                            {Payload?.owning_carrier === 'Q5' && (
                                                            <span tabIndex={0} className="text-primary fw-bold font12" style={{ fontSize: '12px' }}>
                                                                {(paidStatus === 'paid') ? " " + coveragesContent?.coverage_paid_text : " " + coveragesContent?.coverage_unpaid_text}
                                                            </span>
                                                            )}
                                                            {Payload?.owning_carrier !== 'Q5' && (
                                                            <button tabIndex={0} className="btn btn-success btn-md rounded-pill font12" style={{ fontSize: '12px' }}>
                                                                {(paidStatus === 'paid') ? coveragesContent?.coverage_paid_text : coveragesContent?.coverage_unpaid_text}
                                                            </button>
                                                            )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {errorFlag && (
                                                        <div className="api-error-msg">
                                                            {genericContent?.coverage_info_service_error}
                                                        </div>
                                                    )}

                                                            {!errorFlag && !isLoading && (
                                                                <div className="bd-example card-body">
                                                                    <div>
                                                                        <div className="">
                                                                            <div className="bd-example">
                                                                                <Accordion defaultActiveKey={null}>
                                                                                    {coverageHeader?.map((item, index) => (
                                                                                        <TableCard
                                                                                            key={index}
                                                                                            columns={item}
                                                                                            rows={coveragePrd[index]}
                                                                                            eventKey={index.toString()}
                                                                                            activeKey={activeKey}
                                                                                            setActiveKey={setActiveKey}
                                                                                            variant="coverage"
                                                                                        />
                                                                                    ))}
                                                                                </Accordion>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                </div>
                                            )}
                                            {Payload?.owning_carrier !== 'Q5' &&(
                                                <div className="d-xl-flex d-md-flex d-sm-block d-block mb-4 mb-4">
                                                    <div className="col-xl-4 col-md-4 col-sm-12 card-body">
                                                        <div tabIndex={0} className="d-flex">
                                                            <h5 className="fw-semibold me-3">{coveragesContent?.coverage_coverage_details}</h5>
                                                        </div>
                                                        {isLoading && (
                                                            <div tabIndex={0} style={{ display: '-webkit-inline-box', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                                                                <Spinner animation="border" role="status" ></Spinner>
                                                                <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                                            </div>
                                                        )}
                                                        {!errorFlag && !isLoading && (
                                                            <div className="me-2 mt-3">
                                                                <img src={coverageDetailsIcon} className="mw-100 mt-3 coverage-img" alt="coveragedetails" />
                                                            </div>
                                                        )}
                                                    </div>
                                                    {errorFlag && (
                                                        <div className="api-error-msg">
                                                            {genericContent?.coverage_info_service_error}
                                                        </div>
                                                    )}

                                                    {!errorFlag && !isLoading && (
                                                        <div className="col-xl-8 col-md-8 col-sm-12 mt-3 card-body">
                                                            <div className="mb-4">
                                                                <div className="col-12 text-xl-end text-lg-end text-md-end text-sm-start text-start">
                                                                    <div className="d-flex flex-wrap align-items-center justify-content-xl-end justify-content-lg-end justify-content-md-end justify-content-sm-start justify-content-start gap-2">
                                                                    <button
                                                                        type="submit"
                                                                        className="btn btn-primary rounded gap-2"
                                                                    >
                                                                        {coveragePrd?.length} {coveragesContent?.coverage_product_text}
                                                                        {coveragePrd?.length > 1 ? 's' : ''}
                                                                        {coveragesContent?.coverage_enrolled_text}
                                                                    </button>
                                                                    <h6 tabIndex={0} className="fw-semibold mb-0 h6">
                                                                        <img src={creditCoverageIcon}
                                                                            className={`me-1 ${Payload?.owning_carrier === 'Q5' ? 'q5-navy-icon' : ''}`} alt="Coverage-Card" />
                                                                        {coveragesContent?.coverage_next_billing_date_text} {nextBillDate}
                                                                    </h6>
                                                                        <div className="d-flex align-items-center gap-2">
                                                                    <label tabIndex={0} className="mt-1 labels">
                                                                        <span className="label-heading">{coveragesContent?.coverage_status_text}</span>
                                                                    </label>
                                                                    {Payload?.owning_carrier === 'Q5' && (
                                                                    <span className="text-primary fw-bold font12" style={{ fontSize: '12px' }}>
                                                                        {(paidStatus === 'paid') ? " " + coveragesContent?.coverage_paid_text : " " + coveragesContent?.coverage_unpaid_text}
                                                                    </span>
                                                                    )}
                                                                    {Payload?.owning_carrier !== 'Q5' && (
                                                                    <button className="btn btn-success btn-md rounded-pill font12" style={{ fontSize: '12px' }}>
                                                                        {(paidStatus === 'paid') ? coveragesContent?.coverage_paid_text : coveragesContent?.coverage_unpaid_text}
                                                                    </button>
                                                                    )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div className="">
                                                                    <div className="bd-example">
                                                                        <Accordion defaultActiveKey={null}>
                                                                            {coverageHeader?.map((item, index) => (
                                                                                <TableCard
                                                                                    key={index}
                                                                                    columns={item}
                                                                                    rows={coveragePrd[index]}
                                                                                    eventKey={index.toString()}
                                                                                    activeKey={activeKey}
                                                                                    setActiveKey={setActiveKey}
                                                                                    variant="coverage"
                                                                                />
                                                                            ))}
                                                                        </Accordion>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                </div>
                                            )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main> 
        </>
    )
}
export default Coverage;